<script setup lang="ts">
const { data: settings } = useSettings()
</script>

<template>
  <ul v-if="settings?.some" class="flex items-center gap-4">
    <template v-for="provider in SOCIAL_PROVIDERS" :key="provider">
      <li v-if="settings.some[provider]">
        <UiSocialLink
          class="bg-white text-green-50"
          :provider="provider"
          :href="settings.some[provider]!"
        />
      </li>
    </template>
  </ul>
</template>
